import { throttle } from 'es-toolkit';
import { useLayoutEffect } from 'react';

export const useGlobalEventListener = () => {
  useLayoutEffect(() => {
    const updateHeight = () => {
      const height = window.visualViewport?.height || window.innerHeight;

      document.documentElement.style.setProperty(
        '--viewport-height',
        `${height}px`,
      );
    };

    // 초기값은 즉시 설정
    updateHeight();

    // scroll/resize는 throttle 적용 (100ms)
    const throttledUpdateHeight = throttle(updateHeight, 100);

    window.addEventListener('resize', throttledUpdateHeight);
    window.addEventListener('scroll', throttledUpdateHeight);
    window.visualViewport?.addEventListener('resize', throttledUpdateHeight);

    return () => {
      window.removeEventListener('resize', throttledUpdateHeight);
      window.removeEventListener('scroll', throttledUpdateHeight);
      window.visualViewport?.removeEventListener(
        'resize',
        throttledUpdateHeight,
      );
      throttledUpdateHeight.cancel();
    };
  }, []);
};
